import React from 'react';
import { Layout, Menu } from 'antd';
import { matchPath } from 'react-router-dom';
import Icon from '../Icon';
import AdvencedLink from './AdvancedLink';
import './index.less';

import { SiderTheme } from 'antd/es/layout/Sider';

import { Section } from './interface';

interface Props {
  sections: Section[],
  flatSections: Section[],
  theme?: SiderTheme,
  pathname: string
}

const clsPrefix = "c-sider"

const { SubMenu } = Menu;
const { Sider: AntdSider } = Layout;

const LinkBody: React.FC<{
  section: Section
}> = ({ section }) => (
  <span>
    { section.icon && <Icon style={{ marginRight: '10px' }} name={section.icon} /> }
    {section.title}
  </span>
)

const Sider: React.FC<Props> = ({
  sections,
  flatSections,
  theme = 'light',
  pathname
}) => {

  function getCurPage() {
    let curPage = flatSections.filter(section => matchPath(pathname, {
      path: section.href,
      exact: true,
      strict: false
    }))
    if (curPage.length === 0) {
      curPage = flatSections;
    }
    return curPage
  }
  const curPage = getCurPage();

  return (
    <AntdSider
      className={clsPrefix}
      width={180}
      theme={theme}
    >
      <Menu
        mode="inline"
        defaultSelectedKeys={[curPage[0].href || '']}
        // @ts-ignore
        defaultOpenKeys={[curPage[0].parentHref || curPage[0].href || '']}
        theme={theme}
        style={{ height: '100%' }}
      >
        {sections.map(section => (
          section.items ? (
            <SubMenu
              key={section.href}
              title={
                <LinkBody section={section} />
              }
            >
              {section.items.map(item => (
                <Menu.Item key={item.href}>
                  <AdvencedLink {...item}>
                    <LinkBody section={item} />
                  </AdvencedLink>
                </Menu.Item>
              ))}
            </SubMenu>
          ) : (
            <Menu.Item key={section.href}>
              <AdvencedLink {...section}>
                <LinkBody section={section} />
              </AdvencedLink>
            </Menu.Item>
          )
        ))}
    </Menu>
  </AntdSider>
  )
}

export default Sider;